import {Typography} from '@mui/material';

import {BasicTableCell, BasicTableRow} from '../../../../components/BasicTable/BasicTableRow';
import {empionGreen} from '../../../../layouts/theme/EmpionColors';

export interface LocationRow {
  id: string;
  city: string;
  address: string;
  additionalInfo: string;
  zipCode: string;
  country: string;
}

const EMPTY = '—';

const cellSx = {fontSize: '13px', letterSpacing: '0.39px'} as const;

export const CompanyProfileLocationsTableRow = (row: LocationRow) => (
  <BasicTableRow rowVariant='flat'>
    <BasicTableCell>
      <Typography sx={{...cellSx, fontWeight: 600, color: empionGreen[700]}}>{row.city || EMPTY}</Typography>
    </BasicTableCell>
    <BasicTableCell>
      <Typography sx={cellSx}>{row.address || EMPTY}</Typography>
    </BasicTableCell>
    <BasicTableCell>
      <Typography sx={cellSx}>{row.additionalInfo || EMPTY}</Typography>
    </BasicTableCell>
    <BasicTableCell>
      <Typography sx={cellSx}>{row.zipCode || EMPTY}</Typography>
    </BasicTableCell>
    <BasicTableCell>
      <Typography sx={cellSx}>{row.country || EMPTY}</Typography>
    </BasicTableCell>
  </BasicTableRow>
);
